import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef } from '@angular/material'
import { BaseDialogComponent } from '../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../common/stringable.decorator'
import { DialogService } from '../../../services'

const KEY = 'atyl-nomade-security-handler'
@Component({
	selector: 'atyl-nomade-security-handler',
	templateUrl: './security-handler.component.html',
	styleUrls: ['./security-handler.component.scss']
})
@Stringable({
	path: 'nomade/dialogs/security-handler/security-handler',
	key: KEY,
})
export class SecurityHandlerComponent extends BaseDialogComponent implements OnInit {

	securityQuestionForm: FormGroup = new FormGroup({
		securityQuestion: new FormControl('', { validators: [Validators.required] }),
		securityAnswer: new FormControl('', { validators: [Validators.required] })
	})
	securityAnswer: string = ''
	selectedSecurityQuestion: string = ''


	@StringableValues(KEY) strings: any
	securityQuestions: any[]
	constructor(
		dialogRef: MatDialogRef<SecurityHandlerComponent>,
		dialogService: DialogService,
		changeDetectorRef: ChangeDetectorRef
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}
	ngOnInit() {
		this.securityQuestions = this.strings.questions
	}
	saveSecurityQuestion(event: MouseEvent) {
		localStorage.setItem('securityQuestion', window.btoa(this.securityQuestionForm.value.securityQuestion))
		localStorage.setItem('securityAnswer', window.btoa(this.securityQuestionForm.value.securityAnswer))
		this.dialogRef.close(true)
	}

}
